var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs/ReplaySubject';
var ServiceName = "PubSub Service";
var PubSubService = (function () {
    function PubSubService() {
        this.events = {};
    }
    PubSubService.prototype.$sub = function (event, callback, error, complete) {
        if (!event) {
            throw new Error("[" + ServiceName + "] => Subscription method must get event name.");
        }
        if (this.events[event] === undefined) {
            this.events[event] = new ReplaySubject();
        }
        if (typeof callback !== 'function') {
            return this.events[event].asObservable();
        }
        else {
            return this.events[event].asObservable().subscribe(callback, error, complete);
        }
    };
    PubSubService.prototype.$pub = function (event, eventObject) {
        if (!event) {
            throw new Error("[" + ServiceName + "] => Publish method must get event name.");
        }
        else if (!this.events[event]) {
            return;
        }
        this.events[event].next(eventObject);
    };
    return PubSubService;
}());
PubSubService = __decorate([
    Injectable()
], PubSubService);
export { PubSubService };
//# sourceMappingURL=angular2-pubsub.service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-pubsub/esm/src/angular2-pubsub.service.js
// module id = 349
// module chunks = 4